"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _PendingReconciliationDialog = _interopRequireDefault(require("./components/PendingReconciliationDialog.vue"));
var _DownloadBillDialog = _interopRequireDefault(require("./components/DownloadBillDialog.vue"));
var _BillDetailDialog = _interopRequireDefault(require("./components/BillDetailDialog.vue"));
var _BillItemsDialog = _interopRequireDefault(require("./components/BillItemsDialog.vue"));
var _RemarkDialog = _interopRequireDefault(require("./components/RemarkDialog.vue"));
var _CollectionDetailDialog = _interopRequireDefault(require("./components/CollectionDetailDialog.vue"));
var _PaymentDetails = _interopRequireDefault(require("./components/paymentDetails/PaymentDetails.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'MerchantReconciliationList',
  components: {
    PendingReconciliationDialog: _PendingReconciliationDialog.default,
    DownloadBillDialog: _DownloadBillDialog.default,
    BillDetailDialog: _BillDetailDialog.default,
    BillItemsDialog: _BillItemsDialog.default,
    RemarkDialog: _RemarkDialog.default,
    CollectionDetailDialog: _CollectionDetailDialog.default,
    PaymentDetails: _PaymentDetails.default
  },
  data: function data() {
    return {
      constants: this.$constants,
      listPram: {
        page: 1,
        limit: this.$constants.page.limit[0],
        billNo: '',
        orderNo: '',
        merchantType: '',
        merchantId: '',
        hasLoss: '',
        creator: '',
        reconciliationStatus: '',
        paymentStatus: ''
      },
      listLoading: false,
      // 状态映射：0=生成失败，1=生成中，2=已生成
      STATUS_MAP: {
        0: '生成失败',
        1: '生成中',
        2: '已生成'
      },
      // 对账状态映射：0=未核对，1=已核对
      RECONCILIATION_STATUS_MAP: {
        0: '未核对',
        1: '已核对'
      },
      // 打款状态映射：0=未打款，1=已打款，2=部分打款
      PAYMENT_STATUS_MAP: {
        0: '未打款',
        1: '已打款',
        2: '部分打款'
      },
      // 静态 mock 数据
      listData: {
        total: 7,
        list: [{
          id: 10,
          billNo: 'SA2026052500214',
          merchantName: '家家乐',
          merchantType: '获得供应商',
          periodStart: '2019-06-01 00:00',
          periodEnd: '2019-07-30 23:59:59',
          generateTime: '2019-06-21 12:20:25',
          orderCount: 200,
          orderAmount: 10,
          settledAmount: 10,
          actualAmount: 10,
          paymentAmount: 10,
          status: 2,
          reconciliationStatus: 1,
          paymentStatus: 1,
          creatorName: '张三',
          reconciliationRemark: '',
          financeRemark: ''
        }, {
          id: 9,
          billNo: 'SA2026052500214',
          merchantName: '家家乐',
          merchantType: '获得供应商',
          periodStart: '2019-06-01 00:00',
          periodEnd: '2019-07-30 23:59:59',
          generateTime: '2019-06-21 12:20:25',
          orderCount: 300,
          orderAmount: 10,
          settledAmount: 10,
          actualAmount: 10,
          paymentAmount: 5,
          status: 2,
          reconciliationStatus: 1,
          paymentStatus: 2,
          creatorName: '张三',
          reconciliationRemark: '',
          financeRemark: ''
        }, {
          id: 8,
          billNo: 'SA2026052500214',
          merchantName: '家家乐',
          merchantType: '获得供应商',
          periodStart: '2019-06-01 00:00',
          periodEnd: '2019-07-30 23:59:59',
          generateTime: '2019-06-21 12:20:25',
          orderCount: 100,
          orderAmount: 10,
          settledAmount: 10,
          actualAmount: 10,
          paymentAmount: 0,
          status: 2,
          reconciliationStatus: 1,
          paymentStatus: 0,
          creatorName: '张三',
          reconciliationRemark: '',
          financeRemark: ''
        }, {
          id: 7,
          billNo: 'SA2026052500214',
          merchantName: '家家乐',
          merchantType: '获得供应商',
          periodStart: '2019-06-01 00:00',
          periodEnd: '2019-07-30 23:59:59',
          generateTime: '2019-06-21 12:20:25',
          orderCount: 120,
          orderAmount: 10,
          settledAmount: 10,
          actualAmount: 10,
          paymentAmount: 0,
          status: 2,
          reconciliationStatus: 0,
          paymentStatus: 0,
          creatorName: '张三',
          reconciliationRemark: '',
          financeRemark: ''
        }, {
          id: 6,
          billNo: 'SA2026052500214',
          merchantName: '家家乐',
          merchantType: '获得供应商',
          periodStart: '2019-06-01 00:00',
          periodEnd: '2019-07-30 23:59:59',
          generateTime: '2019-06-21 12:20:25',
          orderCount: 0,
          orderAmount: 10,
          settledAmount: 0,
          actualAmount: 0,
          paymentAmount: 0,
          status: 2,
          reconciliationStatus: 0,
          paymentStatus: 0,
          creatorName: '张三',
          reconciliationRemark: '',
          financeRemark: ''
        }, {
          id: 5,
          billNo: 'SA2026052500214',
          merchantName: '家家乐',
          merchantType: '获得供应商',
          periodStart: '2019-06-01 00:00',
          periodEnd: '2019-07-30 23:59:59',
          generateTime: '2019-06-21 12:20:25',
          orderCount: 60,
          orderAmount: 10,
          settledAmount: 10,
          actualAmount: 10,
          paymentAmount: 0,
          status: 1,
          reconciliationStatus: 0,
          paymentStatus: 0,
          creatorName: '张三',
          reconciliationRemark: '',
          financeRemark: ''
        }, {
          id: 4,
          billNo: 'SA2026052500214',
          merchantName: '家家乐',
          merchantType: '获得供应商',
          periodStart: '2019-06-01 00:00',
          periodEnd: '2019-07-30 23:59:59',
          generateTime: '2019-06-21 12:20:25',
          orderCount: 140,
          orderAmount: 10,
          settledAmount: 10,
          actualAmount: 10,
          paymentAmount: 0,
          status: 0,
          reconciliationStatus: 0,
          paymentStatus: 0,
          creatorName: '张三',
          reconciliationRemark: '',
          financeRemark: ''
        }]
      }
    };
  },
  methods: {
    statusClass: function statusClass(status) {
      if (status === 0) return 'text-danger';
      if (status === 1) return 'text-info';
      return '';
    },
    paymentStatusClass: function paymentStatusClass(status) {
      if (status === 2) return 'text-warning';
      return '';
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
    },
    openPendingDialog: function openPendingDialog() {
      this.$refs.pendingDialogRef.open();
    },
    openDownloadBillDialog: function openDownloadBillDialog(row) {
      this.$refs.downloadBillDialogRef.open(row);
    },
    openBillDetailDialog: function openBillDetailDialog(row) {
      this.$refs.billDetailDialogRef.open(row);
    },
    openBillItemsDialog: function openBillItemsDialog(row) {
      this.$refs.billItemsDialogRef.open(row);
    },
    openRemarkDialog: function openRemarkDialog(row, type) {
      this.$refs.remarkDialogRef.open(row, type);
    },
    openCollectionDetailDialog: function openCollectionDetailDialog(row) {
      this.$refs.collectionDetailDialogRef.open(row);
    },
    openPaymentDetailsDialog: function openPaymentDetailsDialog(row) {
      this.$refs.paymentDetailsRef.open(row);
    }
  }
};